import { render, staticRenderFns } from "./_replenish.vue?vue&type=template&id=56678bfc&"
import script from "./_replenish.vue?vue&type=script&lang=js&"
export * from "./_replenish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports